import { useTheme } from "@mui-wrapper";
import { lineClasses } from "@mui/x-charts-pro/LineChart";
import { LineChartPro } from "@mui/x-charts-pro/LineChartPro";
import { CHART_AXIS_LABEL_STYLE, CHART_HEIGHT, CHART_MARGIN, CHART_X_AXIS_HEIGHT, CHART_Y_AXIS_WIDTH } from "@components/analytics/in-house/constants/analytics-constants";
import { shouldRenderXTickLabel } from "@components/analytics/in-house/utils/analytics-utils";
import { PALETTE_VARS } from "@styles/palette-vars";

/** Renders the line variant for in-house analytics data. */
export function AnalyticsLineChart({
  dataset,
  xTickStep,
  yAxisLabel,
  seriesUnitLabel
}) {
  const theme = useTheme();
  const lineSeriesData = dataset.map(({
    value
  }) => value > 0 ? value : null);
  return <>
      {/* eslint-disable @typescript-eslint/naming-convention -- MUI X chart API uses third-party prop names */}
      <LineChartPro height={CHART_HEIGHT} margin={CHART_MARGIN} xAxis={[{
      scaleType: "point",
      data: dataset.map(item => item.label),
      tickLabelInterval: (_value, index) => shouldRenderXTickLabel(index, dataset.length, xTickStep),
      height: CHART_X_AXIS_HEIGHT,
      disableLine: true,
      disableTicks: true,
      tickLabelStyle: {
        fontSize: 14,
        fill: theme.vars.palette.text.secondary
      }
    }]} yAxis={[{
      min: 0,
      width: CHART_Y_AXIS_WIDTH,
      label: yAxisLabel,
      tickMinStep: 1,
      valueFormatter: value_0 => `${Math.round(value_0 ?? 0)}`,
      disableLine: true,
      disableTicks: true,
      labelStyle: {
        fill: theme.vars.palette.text.secondary,
        ...CHART_AXIS_LABEL_STYLE
      },
      tickLabelStyle: {
        fontSize: 14,
        fill: theme.vars.palette.text.secondary,
        transform: "translate(10px, 2px)"
      }
    }]} grid={{
      horizontal: true,
      vertical: false
    }} sx={{
      "&": {
        border: "none",
        outline: "none",
        boxShadow: "none",
        backgroundColor: "transparent"
      },
      ".MuiChartsAxis-root .MuiChartsAxis-tickLabel": {
        transform: "translateY(2px)"
      },
      ".MuiChartsAxis-line": {
        stroke: "transparent"
      },
      ".MuiChartsAxis-tick": {
        stroke: "transparent"
      },
      ".MuiChartsGrid-line": {
        stroke: PALETTE_VARS.divider,
        strokeDasharray: "2 5"
      },
      [`.${lineClasses.line}`]: {
        strokeWidth: 2
      },
      [`.${lineClasses.mark}`]: {
        fill: PALETTE_VARS.background.paper,
        stroke: PALETTE_VARS.primary.light,
        strokeWidth: 2
      }
    }} series={[{
      data: lineSeriesData,
      color: "primary.light",
      connectNulls: true,
      curve: "linear",
      label: undefined,
      type: "line",
      showMark: true,
      valueFormatter: value_1 => `${value_1 ?? 0} ${seriesUnitLabel}`,
      highlightScope: {
        highlight: "none",
        fade: "none"
      }
    }]} />
      {/* eslint-enable @typescript-eslint/naming-convention */}
    </>;
}